import { render, staticRenderFns } from "./fixed_deposit.vue?vue&type=template&id=53d28398&"
import script from "./fixed_deposit.vue?vue&type=script&lang=js&"
export * from "./fixed_deposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports